export const USER_INFO='USER_INFO';
export const MENU_ROUTER_INFO='MENU_ROUTER_INFO';
export const LANGUAGE_TYPE='LANGUAGE_TYPE';
